import { Select } from '@pms-digital/design-system';
import type { SegmentOption } from './export-segmented-control';

interface ExportSelectFieldProps<T extends string> {
  label: string;
  value: T;
  options: readonly SegmentOption<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
  /** Small explanatory line under the select, e.g. why it is disabled. */
  hint?: string | null;
}

/**
 * A labelled select for the export panel's longer enumerations. The picked
 * string is mapped back through `options` rather than cast, so a value the
 * select hands back is only ever one this field offered.
 */
export function ExportSelectField<T extends string>({
  label,
  value,
  options,
  onChange,
  disabled = false,
  hint = null,
}: ExportSelectFieldProps<T>) {
  return (
    <Select
      label={label}
      value={value}
      disabled={disabled}
      help={hint ?? undefined}
      options={options.map((option) => ({ value: option.value, label: option.label }))}
      onValueChange={(picked) => {
        const option = options.find((candidate) => candidate.value === picked);
        if (option) onChange(option.value);
      }}
    />
  );
}
